
import Info from "./Info/Info.jsx";
import Form from "./Form/Form.jsx";
import style from "./Contact.module.css";

const Contact = () => {

    return(
        <div className={style.contact}>
            <div className={style.info}><Info /></div>
            <div className={style.form}><Form /></div>
        </div>
    );
};

export default Contact;